import {gql} from '@apollo/client';

export default gql`
  mutation lockEnd($input: LockInput!) {
    lockEnd(input: $input) {
      success
    }
  }
`;
